import { useEffect, useState } from 'react'
import { HiOutlineColorSwatch } from "react-icons/hi";
import UniversalSelector from './UniversalSelector'

import styleStorage from "../storage/styleStorage"

const styleItems = styleStorage.getAllStyles().map((style) => ({
    id: style.getCode(),
    label: style.getName(),
}))

function StyleSelector({flash, lang})
{
    const [selectedStyle, setSelectedStyle] = useState(styleStorage.getSelectedStyle())

    useEffect(() => {
        setSelectedStyle(styleStorage.getSelectedStyle())
    }, [])

    const selectedStyleName = styleStorage.getStyle(selectedStyle).getName()
    const title = lang.tr("current_style_is", selectedStyleName)

    const selectStyle = (styleId) => {
        if (styleId === selectedStyle) {
            return
        }
        styleStorage.selectStyle(styleId)
        setSelectedStyle(styleId)
        flash.putMessage(lang.tr("style_changed_to", styleStorage.getStyle().getName()), "success")
    }

    return <UniversalSelector
        icon={<HiOutlineColorSwatch />}
        title={title}
        items={styleItems}
        selectedId={selectedStyle}
        onSelect={selectStyle}
        selectionDescriptor={lang.tr("select_style")}
    />
}

export default StyleSelector
